import { BannerType } from '../../banner.types';

export function canDismissBanner(banner: BannerType) {
  if (banner === BannerType.SWITCH_CALL) return false;
  return true;
}
